import { cn } from '@/libs/utils/cn';
import { Spinner } from '../atoms/spinner';

interface LoadingProps {
  content?: string;
  className?: string;
}

export function Loading(props: LoadingProps) {
  const { content, className } = props;
  return (
    <div className={cn('flex w-full min-h-svh justify-center items-center', className)}>
      <Spinner content={content} />
    </div>
  );
}
